module.exports = __webpack_public_path__ + "img/yzh2.8b3e0aca.jpg";